<template>
  <v-card class="d-flex flex-column" outlined :ripple="false" @click="goToNewDashboard">
    <v-img :src="canteenImage || '/static/images/canteen-default-image.jpg'" height="160" max-height="160"></v-img>
    <v-card-title>
      <h3 class="fr-h6 font-weight-bold mb-1">{{ canteen.name }}</h3>
    </v-card-title>
    <v-card-subtitle class="py-1">
      <v-chip
        v-if="teledeclarationIsActive && !usesCentralKitchenDiagnostics"
        small
        :color="teledeclarationStatus.color"
        label
        class="mr-1"
      >
        <p class="mb-0">{{ teledeclarationStatus.text }}</p>
      </v-chip>
      <v-chip small :color="publicationStatus.color" label>
        <p class="mb-0">{{ publicationStatus.text }}</p>
      </v-chip>
    </v-card-subtitle>
    <v-card-subtitle class="mt-0">
      <ProductionTypeTag :canteen="canteen" position="top-left" />
      <CanteenIndicators :canteen="canteen" />
      <v-btn
        color="secondary"
        variant="tonal"
        class="rounded w-md float-right"
        @click.stop="unfollow"
        v-if="this.loggedUser.job == 'CONSUMER'"
      >
        Se désabonner
      </v-btn>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import CanteenIndicators from "@/components/CanteenIndicators"
import ProductionTypeTag from "@/components/ProductionTypeTag"
import { lastYear } from "@/utils"

export default {
  name: "CanteenCard",
  props: {
    canteen: {
      type: Object,
      required: true,
    },
  },
  components: {
    CanteenIndicators,
    ProductionTypeTag,
  },
  data() {
    return {
      teledeclarationYear: lastYear(),
    }
  },
  computed: {
    loggedUser() {
      return this.$store.state.loggedUser
    },
    publicationStatus() {
      return {
        draft: {
          color: "grey lighten-4",
          text: "Non-publiée",
        },
        published: {
          color: "green lighten-4",
          text: "Publiée",
        },
      }[this.canteen.publicationStatus || "draft"]
    },
    teledeclarationStatus() {
      const diagnostics = this.canteen.diagnostics
      const diagnostic = diagnostics.find((d) => d.year === this.teledeclarationYear)
      const teledeclared = diagnostic && diagnostic.teledeclaration && diagnostic.teledeclaration.status === "SUBMITTED"
      if (teledeclared) {
        return {
          color: "green lighten-4",
          text: `Télédéclarée (${this.teledeclarationYear})`,
        }
      } else {
        return {
          color: "grey lighten-4",
          text: `Non-télédéclarée (${this.teledeclarationYear})`,
        }
      }
    },
    usesCentralKitchenDiagnostics() {
      return (
        this.canteen.productionType === "site_cooked_elsewhere" &&
        this.canteen.centralKitchenDiagnostics?.find((d) => d.year === this.teledeclarationYear)
      )
    },
    canteenImage() {
      return this.canteen.leadImage?.image
    },
    teledeclarationIsActive() {
      return window.ENABLE_TELEDECLARATION
    },
  },
  methods: {
    goToNewDashboard() {
      if (this.loggedUser.job == "CONSUMER") {
        this.$router.push({ name: "SurveyLinksHome" })

        //this.$router.push({ name: "ConsumerDashboard" })
      } else if (this.loggedUser.job == "NUTRITIONIST") {
        this.$router.push({ name: "NutritionistDashboardPage" })
      } else {
        this.$router.push({ name: "CantineNewDashboard", params: { canteenId: this.canteen.id } })
      }
    },
    unfollow() {
      const canteenId = this.canteen.id
      return this.$store
        .dispatch("unfollowCanteen", { canteenId })
        .then(() => this.$emit("delete", canteenId))
        .catch((e) => this.$store.dispatch("notifyServerError", e))
    },
  },
}
</script>
